<template>
  <div class="elevation-4" style="margin-top: 6px;">
    <v-layout column data-v-step="7">
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn label="Zoom inn"
                aria-label="Zoom inn" v-on="on" class="zoom-button" depressed @click="zoomIn()">
            <v-icon>add</v-icon>
          </v-btn>
        </template>
        <span>Zoom inn</span>
      </v-tooltip>
      <v-divider style="margin: 0px;"></v-divider>
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn label="Zoom ut"
                aria-label="Zoom ut" class="zoom-button" depressed v-on="on" @click="zoomOut()">
            <v-icon>remove</v-icon>
          </v-btn>
        </template>
        <span>Zoom ut</span>
      </v-tooltip>
    </v-layout>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { loadModules } from "esri-loader";
export default {
  name: "MapZoomNavigation",
  data: function() {
    return {
      zoomViewModel: null
    };
  },
  watch: {
    is3d: function(newVal) {
      if (newVal) {
        this.zoomViewModel.view = this.$theSceneViewObject;
      } else {
        this.zoomViewModel.view = this.$theMapViewObject;
      }
    }
  },
  computed: {
    ...mapState(["is3d"])
  },
  methods: {
    zoomIn: function() {
      this.zoomViewModel.zoomIn();
    },
    zoomOut: function() {
      this.zoomViewModel.zoomOut();
    },
    loadZoom: function() {
      loadModules(["esri/widgets/Zoom/ZoomViewModel"]).then(
        function([ZoomViewModel]) {
          this.zoomViewModel = new ZoomViewModel({
            view: this.$theMapViewObject
          });
        }.bind(this)
      );
    }
  },
  mounted() {
    this.loadZoom();
  }
};
</script>

<style>
.zoom-button {
  max-width: 34px !important;
  min-width: 34px !important;
  max-height: 34px !important;
  margin: 0px;
}
</style>
